export const MARKET_HIGHLIGHTS_NEWS_ITEM = {
  TITLE: [
    'Market Watch',
    'Weekly Economic Commentary',
    'CFRA Morning Briefing'
  ]
}
